
import { mapState } from 'vuex'

import LandingList from './LandingList.vue'
import utils from '@/components/tools/utils'

export default {
  components: { LandingList },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('customer', { merchant: 'merchant', hasAnyAds: 'hasAnyAds' }),
    buttonLink () {
      const routeName = utils.newAdOrMyVehiclesRoute(this.hasAnyAds, this.isMerchant)

      return this.localePath({ name: routeName })
    },
    isMerchant () {
      return typeof this.merchant?.merchantId === 'number'
    }
  },
  methods: {
    getRelativeUrl (image) {
      const { url } = image.data.attributes

      return url.replace(/^.*\/\/[^/]+/, '')
    }
  }
}
